import React from "react";
import { Popover } from "antd";
import { LoadingOutlined } from "@ant-design/icons";
import { 
  IoRefreshCircleOutline, 
  IoCloseCircleOutline, 
  IoChevronForwardCircleOutline 
} from "react-icons/io5";
import * as S from "./style";
import { TicketActionsProps } from "./types";

export const TicketActions: React.FC<TicketActionsProps> = ({
  ticket,
  loadingAction,
  isBusy,
  onContinue,
  onFinishAndCreate,
  onFinishOnly,
}) => {
  const canProceed = ticket.canProceed && !isBusy;

  const actionButtons = [
    {
      id: "continue",
      label: "Continuar Atendimento",
      icon: <IoChevronForwardCircleOutline size={25} />,
      color: "#1890ff",
      handler: onContinue,
      testId: "btn_continue"
    },
    {
      id: "finish_create",
      label: "Finalizar e Abrir Novo",
      icon: <IoRefreshCircleOutline size={25} />,
      color: "#595959",
      handler: onFinishAndCreate,
      testId: "btn_finish_create"
    },
    {
      id: "finish_only",
      label: "Finalizar Protocolo",
      icon: <IoCloseCircleOutline size={25} />,
      color: "#595959",
      handler: onFinishOnly,
      testId: "btn_finish_only"
    },
  ];

  return (
    <S.ActionsContainer>
      {actionButtons.map((btn) => {
        const isLoading = loadingAction === `${btn.id}_${ticket.id}`;
        
        return (
          <Popover key={btn.id} placement="bottom" content={btn.label}>
            {isLoading ? (
              <LoadingOutlined 
                style={{ fontSize: 25, color: btn.color }}
                data-testid={`loading_${btn.id}`}
                data-cy={`loading_${btn.id}`}
              />
            ) : (
              <S.ActionIconWrapper
                $disabled={!canProceed}
                $activeColor={btn.color}
                onClick={canProceed ? () => btn.handler(ticket.id) : undefined}
                data-testid={btn.testId}
                data-cy={btn.testId}
              >
                {btn.icon}
              </S.ActionIconWrapper>
            )}
          </Popover>
        );
      })}
    </S.ActionsContainer>
  );
};